export default __webpack_public_path__ + "static/media/trac_3.583724c1.png";